var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.83997H2V4.83997H18V6.83997ZM16 0.839966H4V2.83997H16V0.839966ZM20 10.84V18.84C20 19.94 19.1 20.84 18 20.84H2C0.9 20.84 0 19.94 0 18.84V10.84C0 9.73997 0.9 8.83997 2 8.83997H18C19.1 8.83997 20 9.73997 20 10.84ZM14 14.84L8 11.57V18.1L14 14.84Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid6);
export default __webpack_public_path__ + "static/media/grid6.6c1f3ce47bae7cd097ac47b439d051af.svg";
export { ForwardRef as ReactComponent };